import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e1864eb2")

_pushScopeId("data-v-e1864eb2")
const _hoisted_1 = { class: "audiences" }
const _hoisted_2 = { class: "control-bar" }
const _hoisted_3 = { class: "search-wrap" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "m-bold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 个用户 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("未同步")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("同步中")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("同步成功")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("同步失败")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("已清空")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("—")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 同步 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 清空用户 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_page_header = _resolveComponent("page-header")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_space = _resolveComponent("el-space")
  const _component_m_table = _resolveComponent("m-table")
  const _component_audiences_dialog = _resolveComponent("audiences-dialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_page_header, { title: "受众管理" })
    ]),
    _createVNode("main", null, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            placeholder: "输入crm标签名称",
            modelValue: _ctx.keyword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
            class: "input-with-select",
            size: "medium",
            style: {"width":"350px"}
          }, {
            append: _withId(() => [
              _createVNode(_component_el_button, {
                size: "medium",
                icon: "el-icon-search",
                onClick: _ctx.search
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_m_table, {
          data: _ctx.tableList,
          loading: _ctx.loading,
          ref: "mTable",
          pagination: _ctx.pagination,
          onCurrentChange: _ctx.pageChange
        }, {
          default: _withId(() => [
            _createVNode(_component_el_table_column, { label: "CRM标签名称" }, {
              default: _withId((tableItem) => [
                _createVNode("div", {
                  class: "m-omit",
                  title: tableItem.row.tag_name
                }, _toDisplayString(tableItem.row.tag_name), 9, ["title"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "标签类型" }, {
              default: _withId((tableItem) => [
                _createTextVNode(_toDisplayString(tableItem.row.type == 1 ? '系统标签' : '人工标签'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "user_count",
              label: "关联用户"
            }, {
              default: _withId((tableItem) => [
                _createVNode("span", _hoisted_5, _toDisplayString(tableItem.row.user_count), 1),
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "状态"
            }, {
              default: _withId((tableItem) => [
                (tableItem.row.status == 0)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "info"
                    }, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (tableItem.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "warning"
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (tableItem.row.status == 2)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 2 }, {
                      default: _withId(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (tableItem.row.status == 3)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 3,
                      type: "danger"
                    }, {
                      default: _withId(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (tableItem.row.status == 4)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 4,
                      type: "success"
                    }, {
                      default: _withId(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "上次操作时间" }, {
              default: _withId((tableItem) => [
                (tableItem.row.update_time)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(tableItem.row.update_time), 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_12
                    ], 64))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "上次同步账号" }, {
              default: _withId((tableItem) => [
                (tableItem.row.criteo_advertiser_names)
                  ? (_openBlock(), _createBlock("div", {
                      key: 0,
                      class: "m-omit2",
                      title: tableItem.row.criteo_advertiser_names
                    }, _toDisplayString(tableItem.row.criteo_advertiser_names), 9, ["title"]))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_13
                    ], 64))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              width: "240"
            }, {
              default: _withId((tableItem) => [
                _createVNode(_component_el_space, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, {
                      loading: tableItem.row.loading,
                      onClick: ($event: any) => (_ctx.showDialog(tableItem.row)),
                      style: {"width":"90px"},
                      size: "medium",
                      disabled: tableItem.row.delLoading
                    }, {
                      default: _withId(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick", "disabled"]),
                    _createVNode(_component_el_button, {
                      loading: tableItem.row.delLoading,
                      onClick: ($event: any) => (_ctx.clear(tableItem.row)),
                      style: {"width":"110px"},
                      size: "medium",
                      disabled: [0, '4'].includes(tableItem.row.status) || tableItem.row.loading
                    }, {
                      default: _withId(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick", "disabled"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "loading", "pagination", "onCurrentChange"])
      ])
    ]),
    _createVNode("section", null, [
      _createVNode(_component_audiences_dialog, {
        "control-show-dialog": _ctx.isShowDialog,
        onClose: _ctx.closeDialog,
        onCancel: _ctx.closeDialog,
        onConfirm: _ctx.syncData,
        list: _ctx.syncList,
        key: _ctx.reloadDialog
      }, null, 8, ["control-show-dialog", "onClose", "onCancel", "onConfirm", "list"])
    ])
  ]))
})